import { Section, Text } from '@react-email/components';

export const EmailFooter = () => {
  return (
    <Section
      style={{
        borderTop: '1px solid #E5E7EB',
        paddingTop: '24px',
        marginTop: '32px',
      }}
    >
      <Text
        style={{
          fontSize: '14px',
          lineHeight: '1.6',
          color: '#174a43',
          fontWeight: '600',
          margin: '0 0 8px',
          textAlign: 'center',
        }}
      >
        Linga AI — Your AI Analyst
      </Text>
      <Text
        style={{
          fontSize: '12px',
          lineHeight: '1.5',
          color: '#6B7280',
          margin: '0 0 16px',
          textAlign: 'center',
        }}
      >
        Automating quarterly reporting, one email at a time.
      </Text>
      <Text
        style={{
          fontSize: '12px',
          lineHeight: '1.5',
          color: '#6B7280',
          margin: '0',
          textAlign: 'center',
        }}
      >
        Need help? Email us at support@lingaai.com
      </Text>
    </Section>
  );
};
